import { createSelector } from 'reselect'
import { b64ToBlob } from '../components/Common/imageCompressor'

const tiposContenidoReducerSelector = state => state.contenidoReducer.getIn(["data"]).toJS()
export const tiposContenidoSelector = createSelector(
    tiposContenidoReducerSelector, (dataField) => {      
      return dataField
    }
  )
